import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ParametreNavService } from 'app/services/parametre/parametre-nav.service';

/** Compte les requêtes HTTP de chargement initial sur les pages parametre. */
@Injectable()
export class ParametreNavHttpInterceptor implements HttpInterceptor {
  private static readonly TRACK_METHODS = new Set(['GET', 'POST', 'PUT', 'PATCH']);

  constructor(private readonly parametreNav: ParametreNavService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.parametreNav.shouldTrackHttpRequest()) {
      return next.handle(request);
    }
    if (!ParametreNavHttpInterceptor.TRACK_METHODS.has(request.method)) {
      return next.handle(request);
    }

    this.parametreNav.beginPageDataLoad();
    return next.handle(request).pipe(finalize(() => this.parametreNav.endPageDataLoad()));
  }
}
